(function(){
  'use strict';

  angular.module('clientDashboardApp.admin.forms', ['clientDashboardApp.admin.forms.phone']);
  angular.module('clientDashboardApp.admin.forms.phone', ['clientDashboardApp.admin.forms.phoneValidation'])
    .directive('phone', Phone);

    function Phone() {
      return {
        restrict: "A",
        template: "<div ng-class='{\"input-group\" : showCountriesDropdown}'>\
                      <div class='input-group-btn' ng-if='showCountriesDropdown'>\
                          <button type='button' class='btn dropdown-toggle' data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'><img ng-src='images/flags/{{currentCountrySettings.id}}.png' style='padding-right:5px' alt='US'/><span class='caret'></span></button>\
                          <ul class='dropdown-menu' style='min-width:0px'>\
                            <li ng-repeat='country in countrySettings'><a href='' ng-click='setCountry(country.id)'> <img ng-src='images/flags/{{country.id}}.png' alt='{{country.id}}'/></a></li>\
                          </ul>\
                      </div><!-- /btn-group -->\
                    <input type='text' phone-validation country='country' min-digits='minDigits' error-type='errorType' max-digits='maxDigits' class='form-control' id='{{inputName}}' name='phone' ng-model='phoneNumber' {{ required ? 'required' : '' }}/>\
                    </div>\
                    <span class='help-block' ng-if='error'>\
                      <span>This is not a valid phone number</span>\
                    </span>",
        scope: {
          error: "=",
          showCountriesDropdown: "=",
          inputName: "@",
          country: "=",
          phoneNumber: "=",
          required: "="
        },
        controller: PhoneCtrl
      }
    }

    PhoneCtrl.$inject = ["$scope"];

    function PhoneCtrl($scope) {

        var previousStr = "";
        var digit = new RegExp(/\d/);
        var init;
        var delta;
        var xtraCharsAdjust;
        var addedFormatting = false;

        $scope.errorType = "none";

      $scope.currentCountrySettings = {
        id:"ALL",
        min:1,
        max:50,
        placeholder:"i.e. (XXX) 123-1234"
      }

      $scope.minMaxEqual = function(){
        return $scope.currentCountrySettings.min == $scope.currentCountrySettings.max;
      }

      $scope.getQuantifier = function(){
        if($scope.errorType == 'under'){
          return $scope.minMaxEqual() ? "exactly" : "at least";
        }
        else if($scope.errorType == 'over'){
          return $scope.minMaxEqual() ? "exactly" : "no greater than";
        }
      }

      $scope.getLimit = function(){
        if($scope.errorType == 'under'){
          return $scope.currentCountrySettings.min ;
        }
        else if($scope.errorType == 'over'){
          return $scope.currentCountrySettings.max ;
        }
      }

        var sections = [
          {
            str: "",
            filter: new RegExp(/\(|\d/),
            test: new RegExp(/^\(\d/),
            pass:false
          },
          {
            str: "",
            filter: digit,
            test: new RegExp(/^\d{2}\) /),
            pass:false
          },
          {
            str: "",
            filter: digit,
            test: new RegExp(/^\d{3}-/),
            pass:false
          },
          {
            str: "",
            filter: digit,
            test: new RegExp(/^\d{4}/),
            pass:false
          }
        ];

        initialize();

        $scope.setCountry = function(id){
          $scope.country = id;
        }

        function processBackspace(){
          var step = getCurrentStep();
          var section = sections[step];
          var prevSection = sections[step > 0 ? step - 1 : step];
          if(section.str.length > 0){
            section.str = section.str.substr(0,section.str.length-1);
            section.pass = false;
          }
          else{
            prevSection.pass = false;
            deleteTrailingNonDigits(prevSection);
            deleteTrailingDigit(prevSection);
          }
        }

        function deleteTrailingNonDigits(section){
          while(section.str.length > 0 && section.str.charAt(section.str.length - 1).search(/\D/)==0){
            section.str = section.str.substr(0,section.str.length-1);
          }
        }

        function deleteTrailingDigit(section){
          section.str = section.str.substr(0,section.str.length-1);
        }

        function processInput(input){
          var step = getCurrentStep();
          var section = sections[step];
          if(input.search(section.filter) >= 0){
            section.str += input;
            section.str = addFormatting(section.str,step)
          }
          if(section.str.search(section.test) >= 0){
            section.pass = true;
          }
        }

        function resetSections() {
          _.each(sections,function(item){
            item.str = "";
            item.pass = false;
          })
        }

        function addFormatting(str,step){
          if(step==0 && str.length == 1){
            if(str.search(/\d/) == 0){
              str = "("+str;
              addedFormatting = true;
            }
          }
          else if(step== 1 && str.length == 2){
             str += ") ";
             addedFormatting = true;
          }
          else if(step==2 && str.length == 3){
             str += "-";
             addedFormatting = true;
          }

          return str;
        }

        function getCurrentStep(){
          var currentStep = 0;
          _.each(sections, function(item,ind){
            if(item.pass){
              currentStep = ind;
              if(ind !== sections.length - 1){
                currentStep += 1;
              }
            }
          })
          return currentStep;
        }

        function getDelta(str) {
          var diff = str.length - previousStr.length;
          if(diff == 0 && str!=previousStr){
            return str.length;
          }
          return diff;
        }

        function initialize(){
          init = true;
          setCountryDependentVars();
        }

        function setCountryDependentVars(){
          xtraCharsAdjust = isFormattableCountry() ? 4 : 0;
          $scope.minDigits = $scope.currentCountrySettings.min;
          $scope.maxDigits = $scope.currentCountrySettings.max;
          $scope.actualMinDigits = $scope.minDigits;
        }

        function allSectionsPass(){
          var allPass = true;
          _.each(sections,function(item){
            if(!item.pass){
              allPass = false;
            }
          });
          return allPass;
        }


        //use this to determine the mask?
        function isFormattableCountry(){
          return false;//$scope.country=="US" || $scope.country=="CA"
        }

        function processPhoneInput(strPristine){
          delta = getDelta(strPristine);

          if(delta == 1) {
            if(!allSectionsPass()){
              processInput(strPristine.charAt(strPristine.length - 1));
            }
          }
          else if(delta == -1){
            processBackspace()
          }
          else if(delta !== 0){
            return processExistingPhone(strPristine);
          }
          return constructNumberFromParts();
        }

        function constructNumberFromParts(){
          var str = "";
          _.each(sections,function(item){
              str += item.str;
          });
          return str;
        }

        function processExistingPhone(string){
            resetSections();
            if(string.length > 0){
              var chars = string.replace(/\D/g,"").split("");
              _.each(chars,function(item){
                processInput(item);
              });
              return constructNumberFromParts();
            }
            else{
              return string;
            }
        }

        function cleanPhoneNumber(string){
          return string.replace(/\D/g,"");
        }

        $scope.$watch('phoneNumber',function(newVal,oldVal){

            if(init){
              if(newVal !== undefined){
                if(isFormattableCountry()){
                  $scope.phoneNumber = processExistingPhone($scope.phoneNumber);
                }
                else{
                  //$scope.phoneNumber = cleanPhoneNumber($scope.phoneNumber)
                }
                init = false;
              }
            }
            else if(newVal !== oldVal && !addedFormatting){
              if(isFormattableCountry()){
                $scope.phoneNumber = processPhoneInput($scope.phoneNumber);
                previousStr = $scope.phoneNumber;

              }
              else{
                //$scope.phoneNumber = cleanPhoneNumber($scope.phoneNumber)
              }

              }
            else if(addedFormatting){
              addedFormatting = false;
            }

        });


        $scope.$watch('country',function(newVal,oldVal){
          if(newVal !== oldVal){
            setCountryDependentVars();
              if(isFormattableCountry()){
                $scope.phoneNumber = processExistingPhone($scope.phoneNumber);
              }
              else{
                //$scope.phoneNumber = cleanPhoneNumber($scope.phoneNumber)
              }
          }
        });
      }

})();


